import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Workflow step: Refresh BPIDs on pending E844D transactions.
 *
 * Queries all sd_e844d rows with status='pending' and compares their
 * enrichment_data BPIDs against the latest rexel_ecpbpid reference data.
 * Updates any rows where the BPID has changed and logs activities with
 * before/after values.
 */
export const refreshPendingBpidsStep = defineStepConfig({
  type: "refresh_pending_bpids",
  name: "Refresh Pending BPIDs",
  description:
    "Refreshes suppCustShipToBpid and suppCustBillToBpid on pending E844D " +
    "transactions from the latest ECPBPID reference data. Logs BPID_REFRESHED " +
    "activities for changed rows with before/after values.",
  category: "Transformation",
  libraryModule: "ShipAndDebit",
  inputSchema: z.object({}),
  outputSchema: z.object({
    refreshedCount: z
      .number()
      .describe("Number of pending transactions whose BPIDs were updated"),
    unchangedCount: z
      .number()
      .describe("Number of pending transactions with no BPID change"),
    errorCount: z.number().describe("Number of rows that failed during update"),
  }),
  configSchema: z.object({
    batchSize: z
      .number()
      .prefault(500)
      .describe("Number of changed rows to update per DB batch"),
  }),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "30 minutes",
    retry: { maximumAttempts: 2 },
  },
});
